// extracted by mini-css-extract-plugin
module.exports = {"itemColumn":"styles_itemColumn__3pR1A","itemTop":"styles_itemTop__VQyx3","itemBottom":"styles_itemBottom__SOUHR","isFullHeight":"styles_isFullHeight__hwXJW"};